import { Flex, Text } from "monday-ui-react-core";
import { Close, Completed } from "monday-ui-react-core/icons";

type Props = {
  success: boolean;
  duration?: number;
};

export function StatusRow({ success, duration }: Props) {
  if (success) {
    return (
      <div style={{ color: "var(--positive-color)" }}>
        <Flex justify={Flex.justify.SPACE_BETWEEN} align={Flex.align.END}>
          <Flex>
            <Completed />
            <Text type={Text.types.TEXT1}>Success!</Text>
          </Flex>
          <Text type={Text.types.TEXT2} color={Text.colors.SECONDARY}>
            <>Duration: {duration} ms</>
          </Text>
        </Flex>
      </div>
    );
  } else {
    return (
      <div style={{ color: "var(--negative-color)" }}>
        <Flex>
          <Close />
          <Text type={Text.types.TEXT1}>Error</Text>
        </Flex>
      </div>
    );
  }
}
